import { LinkImageComponent } from './LinkImage';
export default LinkImageComponent;
